import _objectSpread from "E:\\Workspaces\\VScode\\vue3+TS\\vue\u6848\u4F8B\\cloudMusicProject-master\\node_modules\\@babel\\runtime\\helpers\\esm\\objectSpread2.js";
import { defineComponent, reactive, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { useState } from "@/hooks/mapGet/index.js";
import { useStore } from "vuex";
import Loading from "@/baseui/loading/loading.vue";
import ListDetailNav from "@/components/list-detail/listDetailNav.vue";
import ListDetail from "@/components/list-detail/listDetail.vue";
import Pagination from "@/baseui/pagination/pagination.vue";
import SArtist from "./cpns/SArtist.vue";
import SAlbum from "./cpns/SAlbum.vue";
import SVideo from "./cpns/SVideo.vue";
import SSheet from "./cpns/SSheet.vue";
export default defineComponent({
  name: "SearchContent",
  setup: function setup() {
    var route = useRoute();
    var store = useStore();
    var state = useState("Search", ["searchTypeInfo"]);
    var textType = reactive(["首", "位", "张", "个", "个"]);
    var text = ref("首单曲");
    var curtPage = ref(1);
    var componentId = ref("ListDetail"); //设置动态组件
    //存储动态组件

    var arr = reactive(["ListDetail", "SArtist", "SAlbum", "SVideo", "SSheet"]);
    /* 导航列表 */

    var navList = reactive([{
      type: 1,
      title: "单曲"
    }, {
      type: 100,
      title: "歌手"
    }, {
      type: 10,
      title: "专辑"
    }, {
      type: 1014,
      title: "视频"
    }, {
      type: 1000,
      title: "歌单"
    }]);
    /* 请求数据 */

    var searchResInfo = reactive({
      keywords: route.params.id,
      limit: 32,
      offset: 0,
      type: 1
    }); // //默认请求单曲
    // store.dispatch("Search/getSearchType", searchResInfo);

    /* 导航点击事件 */

    var titleClick = function titleClick(index) {
      //重置分页器数据,                                       搜索封装的SVideo的videoList分页器有bug！！！！
      searchResInfo.limit = 32;
      searchResInfo.offset = 0;
      curtPage.value = 1; //设置标题值

      text.value = textType[index] + navList[index].title; //动态组件

      componentId.value = arr[index]; //设置请求类型

      searchResInfo.type = navList[index].type; //请求不同类型数据

      store.dispatch("Search/getSearchType", searchResInfo);
    };
    /* 页数改变事件 */


    var changeCurrent = function changeCurrent(page) {
      //页数
      curtPage.value = page; //条数

      searchResInfo.offset = (page - 1) * searchResInfo.limit; //请求

      store.dispatch("Search/getSearchType", searchResInfo);
    };
    /* 当路由id变化则重新请求数据 */


    watch(function () {
      return route.params.id;
    }, function () {
      if (route.path.indexOf("/main/searchContent") !== -1) {
        searchResInfo.keywords = route.params.id;
        store.dispatch("Search/getSearchType", searchResInfo);
      }
    }, {
      immediate: true
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      route: route,
      text: text,
      navList: navList,
      searchResInfo: searchResInfo,
      componentId: componentId,
      curtPage: curtPage,
      titleClick: titleClick,
      changeCurrent: changeCurrent
    });
  },
  components: {
    ListDetailNav: ListDetailNav,
    ListDetail: ListDetail,
    SArtist: SArtist,
    SAlbum: SAlbum,
    SVideo: SVideo,
    SSheet: SSheet,
    Pagination: Pagination,
    Loading: Loading
  }
});